const checkFieldDataType = {}

import { format }from 'date-fns';

checkFieldDataType.install = function (Vue) {
  /*
  * Valida el tipo de campo y lo formatea según sus características
  */
  Vue.filter('checkFieldDataType', (value, field) => {
    if (field.type === 'date') {
      return format(new Date(value), "yyyy-MM-dd")
    }
    return value
  })
}

export default checkFieldDataType



// WEBPACK FOOTER //
// ./src/utils/filters/checkFieldDataType.js